import { CircularProgress, Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useGetJobOfferTemplate } from './hooks/useGetJobOfferTemplate';
import JobOfferTemplateForm from './forms/JobOfferTemplateForm';
import { useNavigate } from 'react-router-dom';

const JobOfferTemplateEdit: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const navigate = useNavigate();

    const { template, loading, error } = useGetJobOfferTemplate(slug);

    if (loading) {
        return (
            <Container sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
                <CircularProgress />
            </Container>
        );
    }

    if (error || !template) {
        return (
            <Container>
                <Typography color="error">Modèle introuvable.</Typography>
            </Container>
        );
    }

    return (
        <JobOfferTemplateForm
            proId={template?.pro?._id}
            template={template}
            onSuccess={(result) => {
                if (result?.jobNumber) {
                    navigate(`/job-offer-templates/${result.jobNumber}/detail`);
                } else {
                    navigate('/job-offer-templates');
                }
            }}
        />
    );
};

export default JobOfferTemplateEdit;
